import { Stack } from "@mui/material";
import { useContext } from "react";
import Image from "src/components/Image";

import Context from "../../context";

// ----------------------------------------------------------------------

export const CustomLogo = () => {
	const { values } = useContext(Context);

	return (
		<Stack
			sx={{
				width: "100%",
				height: 45,
				alignItems: "center",
				justifyContent: "flex-start",
				position: "relative",
				mb: 4
			}}
		>
			<Image
				sx={{
					height: 45,
					position: "absolute",
					left: 0
				}}
				src={URL.createObjectURL(values.file!)}
				fit='cover'
			/>
		</Stack>
	);
};

export default CustomLogo;
